export enum ChevronBrandColors {
    // Blues
    DarkBlue = '#0B2D71',      // Pantone® 288 C
    MediumBlue = '#0066B2',    // Pantone® 2945 C
    LightBlue = '#009DD9',     // Pantone® Process Cyan

    // Teals
    DarkTeal = '#003653',      // Pantone® 2189 C
    MediumTeal = '#00708C',    // Pantone® 633 C
    LightTeal = '#00B2BD',     // Pantone® 7710 C

    // Greens
    DarkGreen = '#444B0D',     // Pantone® 5747 C
    MediumGreen = '#769231',   // Pantone® 575 C
    LightGreen = '#B2CC34',    // Pantone® 2300 C

    // Oranges
    DarkOrange = '#711B00',    // Pantone® 175 C
    MediumOrange = '#E5601F',  // Pantone® 159 C
    LightOrange = '#FAAB18',   // Pantone® 124 C

    // Reds
    DarkRed = '#58001C',       // Pantone® 490 C
    MediumRed = '#97002E',     // Pantone® 202 C
    LightRed = '#E21836',      // Pantone® 186 C

    // Purples
    DarkPurple = '#3A0D36',    // Pantone® 518 C
    MediumPurple = '#751269',  // Pantone® 255 C
    LightPurple = '#BA3093',   // Pantone® 248 C

    // Grays
    DarkGray = '#6B6D6F',
    MediumGray = '#8C8F93',
    LightGray = '#DBDCDD'
}